import { render, staticRenderFns } from "./IExpansionCard.vue?vue&type=template&id=78618ae8&functional=true&"
import script from "./IExpansionCard.vue?vue&type=script&lang=js&"
export * from "./IExpansionCard.vue?vue&type=script&lang=js&"
import style0 from "./IExpansionCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports